import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { ActivityProgress } from 'components/misc'
import { SectionCardMultiple } from 'components/sections/dashboard'
import {
  ACTIVITY_SECTIONS,
  ACTIVITY_STATES,
  AJ_EVENT_CATEGORIES, ASSESSOR_WWC_STATE_TYPES, AWARD_TYPES
} from 'constants/enums'
import styles from './a-j-item-wrap.styl'
import { transformJourneys } from 'helpers/selectors'

const click = {
  openOverview: [
    ACTIVITY_STATES.award_leader_singoff.id,
    ACTIVITY_STATES.in_progress.id,
    ACTIVITY_STATES.assessment.id
  ],
  newActivity: [ACTIVITY_STATES.setup.id],
  waitingNotification: [ACTIVITY_STATES.waiting_for_approval.id],
  completed: [
    ACTIVITY_STATES.complete.id,
    ACTIVITY_STATES.ceremony.id,
    ACTIVITY_STATES.office_signoff.id
  ]
}

const initialJourneyStates = [
  ACTIVITY_STATES.setup.id,
  ACTIVITY_STATES.setup.id,
  ACTIVITY_STATES.setup.id
]

@injectIntl
class AJItemWrap extends Component {
  static propTypes = {
    ajProgress: PropTypes.array,
    canSetupSections: PropTypes.bool,
    notification: PropTypes.func.isRequired,
    onOpenDetail: PropTypes.func,
    onOpenNewJourney: PropTypes.func,
    onOpenTrainAndPrep: PropTypes.func,
    onOpenNewTrainAndPrep: PropTypes.func,
    onShowReviseMessage: PropTypes.func,
    aJValues: PropTypes.object,
    intl: PropTypes.object,
    isBlocked: PropTypes.bool,
    notifyBlockedAward: PropTypes.func,
    awardType: PropTypes.object
  }

  createEmptyPractice = () => ({
    id: AJ_EVENT_CATEGORIES.practice.index,
    url: AJ_EVENT_CATEGORIES.practice.url,
    title: 'Practice',
    titleKey: 'moduleTitle.practice',
    ajEventCategoryType: AJ_EVENT_CATEGORIES.practice.id,
    state: { value: ACTIVITY_STATES.setup.id }
  })

  createEmptyQualifying = () => ({
    id: AJ_EVENT_CATEGORIES.qualification.index,
    url: AJ_EVENT_CATEGORIES.qualification.url,
    title: 'Qualifying',
    titleKey: 'moduleTitle.qualifying',
    ajEventCategoryType: AJ_EVENT_CATEGORIES.qualification.id,
    state: { value: ACTIVITY_STATES.setup.id }
  })

  createEmptyPrepAndTrain = ({
    state,
    returnedToParticipant,
    signOffActionId,
    signoffRequestActionId
  }) => ({
    id: AJ_EVENT_CATEGORIES.trainingAndPrep.index,
    url: AJ_EVENT_CATEGORIES.trainingAndPrep.url,
    title: 'Preparation and Training',
    titleKey: 'moduleTitle.preparation_and_training',
    ajEventCategoryType: AJ_EVENT_CATEGORIES.trainingAndPrep.id,
    state: { value: state || ACTIVITY_STATES.setup.id },
    returnedToParticipant,
    signOffActionId,
    signoffRequestActionId
  })

  getPrepAndTrainData = () => ({
    state: get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingStateType.value'
    ),
    returnedToParticipant: get(
      this.props.aJValues,
      'data.isAjPreparationAndTrainingReturnedToParticipant',
      false
    ),
    signOffActionId: get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingsSignoffActionId'
    ),
    signoffRequestActionId: get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingsSignoffRequestActionId'
    )
  })



  getCategories = () => {
    const journeys = get(this.props.aJValues, 'data.adventurousJourneys', [])
    const prepAndTrain = this.getPrepAndTrainData()
    const categories = [this.createEmptyPrepAndTrain(prepAndTrain)]
    const transformed = transformJourneys(journeys) || []
    const practiceJs = transformed.filter(
      j => get(j, 'ajEventCategoryType') === AJ_EVENT_CATEGORIES.practice.id
    )
    const qualificationJs = transformed.filter(
      j =>
        get(j, 'ajEventCategoryType') === AJ_EVENT_CATEGORIES.qualification.id
    )

    if (!practiceJs || !practiceJs.length) {
      categories.push(this.createEmptyPractice())
    } else {
      categories.push(...practiceJs)
    }

    if (!qualificationJs || !qualificationJs.length) {
      categories.push(this.createEmptyQualifying())
    } else {
      categories.push(...qualificationJs)
    }

    return categories
  }

  getTitleMessage = (title, item) => {
    const awardType = this.props.awardType

    const showPracticeAwardSimplified = get(awardType, 'value') === AWARD_TYPES.simplified.id

    const isPracticeAJ = get(item, 'ajEventCategoryType') === AJ_EVENT_CATEGORIES.practice.id

    if(showPracticeAwardSimplified && isPracticeAJ) {
      return (<div><FormattedMessage
        id='moduleTitle.event_journey'
        defaultMessage='{event} Journey'
        values={{
          event:
            title ||
            this.props.intl.formatMessage({
              defaultMessage: item.title,
              id: item.titleKey
            })
        }}
      />
      <FormattedMessage
        id='moduleTitle.not_required'
        defaultMessage=' (not required)'
      />
      </div>)
    } else {
      return (<FormattedMessage
        id='moduleTitle.event_journey'
        defaultMessage='{event} Journey'
        values={{
          event:
            title ||
            this.props.intl.formatMessage({
              defaultMessage: item.title,
              id: item.titleKey
            })
        }}
      />)
    }


}

  getTitle = item => {
    const title = get(item, 'ajEvent.ajEventCategory.translationText')

    if (
      get(item, 'ajEventCategoryType') ===
      AJ_EVENT_CATEGORIES.trainingAndPrep.id
    ) {
      return (
        <FormattedMessage
          id="moduleTitle.preparation_and_training"
          defaultMessage="Preparation and Training"
        />
      )
    }

    return this.getTitleMessage(title, item)
  }

  handleClick = item => {
    const {
      canSetupSections,
      notification,
      isBlocked,
      notifyBlockedAward
    } = this.props
    const state = get(item, 'state.value', ACTIVITY_STATES.setup.id)
    const type = get(item, 'ajEventCategoryType')
    const prepAndTrainState = get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingStateType.value'
    )

    if (isBlocked) {
      notifyBlockedAward()
    } else if (
      (click.openOverview.includes(prepAndTrainState) ||
        click.completed.includes(prepAndTrainState)) &&
      type === AJ_EVENT_CATEGORIES.trainingAndPrep.id
    ) {
      return this.props.onOpenTrainAndPrep()
    } else if (!canSetupSections) {
      notification(
        'Adventurous Journey cannot be created until your registration is approved',
        {
          intlKey:
            'notifications.adventurous_journey_cannot_be_created_until_approved',
          status: 'info'
        }
      )
    } else if (type === AJ_EVENT_CATEGORIES.trainingAndPrep.id) {
      this.props.onOpenNewTrainAndPrep(item)
    } else if (
      type === AJ_EVENT_CATEGORIES.qualification.id &&
      this.hasActiveQualificationJ(item)
    ) {
      return notification(
        'Only one Qualifying Adventurous Journey can be set-up within the Award',
        {
          intlKey: 'notifications.only_one_qualification_journey_per_award',
          status: 'info'
        }
      )
    } else if (click.newActivity.includes(state)) {
      this.props.onOpenNewJourney(item)
    } else if (
      click.openOverview.includes(state) ||
      click.completed.includes(state)
    ) {
      const { url, id } = transformJourneys(item)

      this.props.onOpenDetail({ categoryUrl: url, id })
    } else if (click.waitingNotification.includes(state)) {
      notification('Waiting for approval', {
        intlKey: 'notifications.waiting_for_approval',
        status: 'info'
      })
    }
  }

  hasActiveQualificationJ = item => {
    const { aJValues } = this.props
    const journeys = get(aJValues, 'data.adventurousJourneys', [])
    // if >1 QAJ is in different state than setup && it's not the current qualy (= there are more qualys)

    return journeys
      .filter(
        journey =>
          get(journey, 'ajEventCategoryType') ===
          AJ_EVENT_CATEGORIES.qualification.id
      )
      .some(
        journey =>
          get(journey, 'state.value') !== ACTIVITY_STATES.setup.id &&
          get(journey, 'id') !== get(item, 'id') &&
          get(item, 'state.value') === ACTIVITY_STATES.setup.id
      )
  }

  determineIcon = item => {
    const state = get(item, 'state.value')
    const isAssessmentPositive = get(item, 'isAssessmentPositive')
    const returnedToParticipant = get(item, 'returnedToParticipant')

    if (
      get(item, 'ajEventCategoryType') ===
        AJ_EVENT_CATEGORIES.qualification.id &&
      this.hasActiveQualificationJ(item)
    ) {
      return
    }

    return {
      checked: [
        ACTIVITY_STATES.complete.id,
        ACTIVITY_STATES.ceremony.id,
        ACTIVITY_STATES.office_signoff.id
      ].includes(state),
      pending:
        [
          ACTIVITY_STATES.waiting_for_approval.id,
          ACTIVITY_STATES.award_leader_singoff.id
        ].includes(state) ||
        ([ACTIVITY_STATES.assessment.id].includes(state) &&
          !isAssessmentPositive),
      warning:
        [
          ACTIVITY_STATES.setup.id,
          // ACTIVITY_STATES.assessment.id,
          ACTIVITY_STATES.in_progress.id
        ].includes(state) && returnedToParticipant,
      add: [ACTIVITY_STATES.setup.id].includes(state),
      sendReport: [
        ACTIVITY_STATES.in_progress.id,
        ACTIVITY_STATES.assessment.id
      ].includes(state)
    }
  }

  handleWarningClick = (e, item) => {
    e.stopPropagation()
    this.props.onShowReviseMessage(item)
  }

  render() {
    const { aJValues, ajProgress } = this.props



    const ajSection = ACTIVITY_SECTIONS.adventurous_journey.id
    const journey = get(aJValues, 'data')
    const journeys = get(journey, 'adventurousJourneys', [])
    const prepAndTrainState = get(
      journey,
      'ajPreparationAndTrainingStateType.value'
    )
    let ajStates = initialJourneyStates

    if (journey) {
      ajStates = [prepAndTrainState]

      for (let i = 0; i < 2; i++) {
        if (journeys && journeys[i]) {
          ajStates.push(get(journeys[i], 'state.value'))
        } else {
          ajStates.push(ACTIVITY_STATES.setup.id)
        }
      }
    }

    return (
      <SectionCardMultiple
        isAJ
        activities={this.getCategories()}
        onClick={this.handleClick}
        activitySection={ajSection}
        title={
          <FormattedMessage
            id="moduleTitle.adventurous_journey"
            defaultMessage="Adventurous journey"
          />
        }
        caption={
          <FormattedMessage
            id="label.adventurous_journey"
            defaultMessage="Adventurous journey"
          />
        }
        activityState={ajStates}
        activityProgress={
          <div className={styles.progressWrap}>
            {ajProgress.map((item, index) => (
              <div className={styles.progressItem} key={index}>
                <ActivityProgress
                  activitySection={ajSection}
                  completedPercentage={item ? 100 : 0}
                />
              </div>
            ))}
          </div>
        }
        showProgress
        onWarningClick={this.handleWarningClick}
        onGetTitle={this.getTitle}
        onGetIcon={item => this.determineIcon(item)}
      />
    )
  }
}

export default AJItemWrap
